import type { PartnerService } from '@duck/api-definitions'

/**
 * Cohort PUT is a full replace on the server, so every call must carry every
 * persisted field, including both messages, or they get wiped.
 */
export const cohortPutPayload = (
  cohort: PartnerService.Cohort,
  patch: Partial<PartnerService.UpdateCohortRequest> = {},
): PartnerService.UpdateCohortRequest => {
  const base: PartnerService.UpdateCohortRequest = {
    name: cohort.name,
    organizationId: cohort.organizationId,
    type: cohort.type,
    isActive: cohort.isActive,
    personIds: cohort.personIds ?? [],
    ...(cohort.description ? { description: cohort.description } : {}),
    ...(cohort.challengeDisclaimer ? { challengeDisclaimer: cohort.challengeDisclaimer } : {}),
    ...(cohort.submitDisclaimer ? { submitDisclaimer: cohort.submitDisclaimer } : {}),
  }
  const merged = { ...base, ...patch }
  // An explicit empty string in the patch means "clear": drop the key so the replace omits it.
  if (merged.challengeDisclaimer === '') delete merged.challengeDisclaimer
  if (merged.submitDisclaimer === '') delete merged.submitDisclaimer
  if (merged.description === '') delete merged.description
  return merged
}
